<template>
  <quote-preview
  :quote="quote"
  :imageUrl="quote.logo"
  :quotedDateFormatted="this.formatDate(quote.quoted_date)"
  pdf="pdf"></quote-preview>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'

import { formatDate } from '@/components/Mixins/formatDate'
import QuotePreview from '@/components/Quote/QuotePreview'

export default {
  name: 'QuotePDF',
  components: {
    QuotePreview
  },
  mixins: [formatDate],
  data () {
    return {
      showPay: false,
      itemId: this.$route.params.invoice_id,
      groupId: this.$route.params.group_id,
      customerEmail: this.$route.query.e,
      complete: false,
      invoiceIsPaid: false,
      quote: {
        id: '',
        title: '',
        clientName: '',
        amount: '',
        contact: '',
        invoice_ref: '',
        invoiced_date: '',
        paid_date: '',
        chargeTax: false,
        taxRate: '',
        clientAddress: '',
        postCode: '',
        groupTitle: '',
        groupAddress: '',
        logo: '',
        logoWidth: 120,
        logoAlign: 'center',
        paymentTerms: '',
        totalNet: 0,
        totalTax: 0,
        totalGross: 0,
        lineItems: [],
        status: 'Unsent'
      }
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      // check for existing invoice, if so grab all items from this
      try {
        this.$store.commit('setLoading', true)
        const getCustomerQuote = firebase.functions().httpsCallable('getCustomerQuote')
        const response = await getCustomerQuote({ groupId: this.$route.params.group_id, quoteId: this.$route.params.quote_id })
        this.quote = response.data
        this.$store.commit('setLoading', false)
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    },
    logRead () {
      const readMsg = {
        created: Date.now(),
        status: 'Quote downloaded'
      }
      firebase.database().ref('invoices-activity/' + this.$route.params.group_id + '/' + this.$route.params.quote_id).push(readMsg)
        .then((data) => {
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
    }
  },
  created () {
    this.fetchData()
    this.logRead()
  }
}
</script>

<style lang="scss">
h1{
  width:100%;
  display:block;
}
</style>
